define('TescoMobile_Catalog/js/view/ab-product-config',['uiComponent', 'ko', 'jquery', 'mage/translate', 'Magento_Catalog/js/price-utils', 'TescoMobile_Catalog/js/model/deal', 'priceBox'], function (Component, ko, $, $t, priceUtils, deal) {
  'use strict';

  return Component.extend({
    defaults: {
      monthlyPhonePayment: 0,
      monthlyTotal: 0,
      arp: 0,
      tenure: 0,
      puf: 0,
      productType: 'paym',
      tariffData: null,
      addToCartFormSelector: '#product_addtocart_form',
      addToCartBox: '#product_addtocart_form .box-tocart'
    },
    initObservable: function () {
      this._super().observe(['monthlyPhonePayment', 'tariffData', 'monthlyTotal', 'tenure', 'puf', 'productType']);
      return this;
    },
    initialize: function () {
      this._super();
      $(document).on('DynamicOptionsPriceUpdateBefore afterTariffUpdate', $.proxy(this._updateState, this));
      $(document).on('DynamicOptionsPriceUpdateAfter', $.proxy(this._updateMonthlyTotal, this));
      if (!this.tariffData()) {
        this._updateState();
      }
      $(document).trigger('selectDeviceOptionsEvent');
      $(this.addToCartFormSelector).submit(this.setTmAccountType.bind(this));
    },
    setTmAccountType: function () {
      let isAssistedChannel = ['instore', 'telesales'].includes(localStorage.getItem('colleague_type'));
      if (!isAssistedChannel) {
        window.location.href.includes("business") ? localStorage.setItem('tm_account_type', 'business') : localStorage.setItem('tm_account_type', 'personal');
      }
    },
    getArp: function () {
      return this.arp + '% ';
    },
    getFormattedPrice(price) {
      let observablePrice = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return priceUtils.formatPrice(price);
    },
    _updateState: function (event, data) {
      if (deal.puf === 'all') {
        deal.deviceMonthlyPrice = 0;
        deal.tenure = 0;
      }
      this.monthlyPhonePayment(deal.deviceMonthlyPrice);
      this.tariffData(deal.tariffSelectionData);
      this.tenure(deal.tenure);
      this.puf(deal.puf);
      if (deal.puf === 'all') {
        this.puf(deal.deviceFullPrice);
      }
    },
    _updateMonthlyTotal: function (event, data) {
      this.monthlyTotal(data);
    },
    getTenure: function () {
      let tenure = this.tenure();
      if (tenure > 0) {
        return $t('Over') + ' ' + this.tenure() + ' ' + $t('months');
      }
      return false;
    },
    getPuf: function () {
      let puf = this.puf(),
        pufLabel = $t('upfront');
      if (puf === 'all') {
        puf = deal.deviceFullPrice;
        pufLabel = $t('Full price');
      }
      return this.getFormattedPrice(puf, false) + ' ' + pufLabel;
    },
    isBau: function () {
      return this.contractType.indexOf('BAU') !== -1;
    },
    paygActionBarData: function () {
      $(document).trigger('tm:paygActionBarReload');
    },
    isInStock: function () {
      let toCartElem = $('.product-details > .box-tocart');
      return toCartElem.length;
    },
    getButtonLabel: function () {
      return $(this.addToCartBox).hasClass("update") ? $t('Update basket') : $t('Add to basket');
    },
    emulateAddToBasketPayMonthly: function () {
      let self = this;
      $("button#emulate-button-pay-monthly").on('click', function () {
        $(self.addToCartFormSelector).trigger('submit');
      });
    },
    emulateAddToBasketPayAsYouGo: function () {
      $("a#emulate-button-pay-as-you-go").on('click', function () {
        let url = $(".payg-add-to-cart-btn a.tocart").attr('href');
        $(this).attr("href", url);
      });
    },
    emulateAddToBasketSimFree: function () {
      $("a#emulate-button-sim-free").on('click', function () {
        let url = $(".sim-free-add-to-cart-btn a.tocart").attr('href');
        $(this).attr("href", url);
      });
    },
    emulateAddToBasketBau: function () {
      let self = this;
      $("button#emulate-button-bau").on('click', function () {
        $(self.addToCartFormSelector).trigger('submit');
      });
    }
  });
});

